import { motion } from "framer-motion";

const accent = {
  border: "rgba(0,255,136,0.28)",
  glow: "0 0 44px rgba(0,255,136,0.22)",
};

export function RegionSelector({ onSelect }) {
  return (
    <motion.div
      className="
        fixed inset-0 z-[100]
        flex items-center justify-center
        bg-black/80
        backdrop-blur-md
      "
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <motion.div
        className="
          glass
          relative
          w-[90%]
          max-w-xl
          overflow-hidden
          border
          px-6
          py-5
        "
        style={{
          borderColor: accent.border,
          boxShadow: accent.glow,
        }}
        initial={{ scale: 0.96, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
      >
        <h2
          className="
            text-center
            font-display
            text-3xl
            font-black
            uppercase
            tracking-tight
            text-white
          "
        >
          Comik Releaf
          <br />
          <span className="text-emerald-300">
            Select Your Region
          </span>
        </h2>

        <div
          className="
            mt-3
            h-px
            w-full
            bg-gradient-to-r
            from-emerald-400/60
            via-emerald-400/20
            to-transparent
          "
        />

        <p
          className="
            mt-4
            text-center
            font-mono
            text-sm
            text-white/60
          "
        >
          Where are you shopping from?
        </p>

        <div className="mt-5 flex gap-3">
          <button
            type="button"
            onClick={() => onSelect("CA")}
            className="
              flex-1
              border
              border-emerald-400/40
              bg-emerald-400/[0.04]
              px-5
              py-4
              font-mono
              text-sm
              font-bold
              uppercase
              tracking-wider
              text-emerald-300
              transition-all
              duration-300
              hover:border-emerald-300
              hover:bg-emerald-400/10
              hover:text-emerald-200
            "
          >
            🇨🇦 Canada
            <div className="mt-1 text-[9px] text-white/30">
              Prices in CAD
            </div>
          </button>

          <button
            type="button"
            onClick={() => onSelect("US")}
            className="
              flex-1
              border
              border-white/10
              bg-white/[0.02]
              px-5
              py-4
              font-mono
              text-sm
              font-bold
              uppercase
              tracking-wider
              text-white/60
              transition-all
              duration-300
              hover:border-white/25
              hover:bg-white/5
              hover:text-white/80
            "
          >
            🇺🇸 United States
            <div className="mt-1 text-[9px] text-white/30">
              Prices in USD
            </div>
          </button>
        </div>

        <div
          className="
            mt-3
            text-center
            font-mono
            text-[9px]
            uppercase
            tracking-[0.25em]
            text-white/20
          "
        >
          Your selection determines displayed pricing
        </div>
      </motion.div>
    </motion.div>
  );
}

export default RegionSelector;
